import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import AddNewWriter from "./AddNewWriter";
import {useDebounce} from "@uidotdev/usehooks";
import {useNavigate} from "react-router-dom";
import {MagazineWriterService} from "../../serverService/magazineService/MagazineWriterService";
import {css} from "@emotion/css";
import {
    convertUniversalDateTimeToPersianDateTime,
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoChipTypes,
    RaikoCustomSimpleChip, RaikoCustomTable,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoMobileInputOutlined,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    showErrorMessage,
    RaikoTableTitleContainer
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function MagazineWriters() {

    const size = 50
    let page = 0
    const navigate = useNavigate()
    const service = new MagazineWriterService()

    const [dialogState, setDialogState] = useState(false);
    const [totalItems, setTotalItems] = useState(0);
    const [tableListShimmerState, setTableListShimmerState] = useState(false);
    const [writers, setWriters] = useState([]);
    const [pageCount, setPageCount] = useState(0);

    const [fullName, setFullName] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");

    const _fullNameFilter = useDebounce(fullName, 500);
    const _nationalCodeFilter = useDebounce(nationalCode, 500);
    const _phoneNumberFilter = useDebounce(phoneNumber, 500);

    useEffect(() => {
        getDataFromServer()
    }, [_fullNameFilter, _phoneNumberFilter, _nationalCodeFilter]);

    function handlePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function prepareWriterTableInfo(number, id, fullName, nationalCode, phoneNumber, createdBy, createdAt, enabled) {
        return {
            number,
            id,
            fullName,
            nationalCode,
            phone: phoneNumber,
            createdBy,
            createdAt: convertUniversalDateTimeToPersianDateTime(createdAt),
            enabled: enabled ?
                <RaikoCustomSimpleChip type={RaikoChipTypes.success} title={"فعال"}/> :
                <RaikoCustomSimpleChip type={RaikoChipTypes.error} title={"غیرفعال"}/>
            ,
        };
    }

    function getDataFromServer() {
        setTableListShimmerState(true)
        service.getWriters(
            page,
            size,
            _fullNameFilter,
            _nationalCodeFilter,
            _phoneNumberFilter
        ).then(response => {

            setPageCount(response.totalPage)
            setTotalItems(response.numberOfItems)

            setWriters([])

            response.data.map((item, index) => {
                setWriters(prev => [
                    ...prev,
                    prepareWriterTableInfo(
                        (page * size) + index + 1,
                        item.id,
                        `${item.firstName} ${item.lastName} `,
                        item.nationalCode,
                        item.phoneNumber,
                        item.createdBy,
                        item.createdAt,
                        item.enabled
                    )
                ])
            })

        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableListShimmerState(false)
        })
    }

    function handleSelectWriter(writerId) {
        let writerName = ""
        writers.map((item) => {
            if (item.id === writerId) {
                writerName = item.fullName
            }
        })

        navigate(
            RouteHelper.MagazineWriterDetail.globalUrl.replace(":id", writerId),
            {state: {title: writerName}, replace: false}
        )
    }

    function addNewWriterToPreviewList(writerInfo) {
        const _writers = writers
        setTotalItems(totalItems + 1)

        setWriters([])
        setWriters(
            [prepareWriterTableInfo(
                1,
                writerInfo.id,
                `${writerInfo.firstName} ${writerInfo.lastName} `,
                writerInfo.nationalCode,
                writerInfo.phoneNumber,
                writerInfo.createdBy,
                writerInfo.createdAt,
                writerInfo.enabled
            )]
        )

        if (_writers.length > 0) {
            _writers.map((item, index) => {
                setWriters(prev => [
                    ...prev,
                    {
                        ...item,
                        number: item.number + 1
                    }
                ])
            })
        }

        setDialogState(false)
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.MagazineWriters.name}</title>
            </Helmet>

            <RaikoDefaultDialogPage
                onClose={_ => setDialogState(false)}
                open={dialogState}
                pageTitle={"افزودن نویسنده جدید"}
                dialogSize={DialogSize.SMALL}>
                <AddNewWriter addNewWriterToPreviewList={addNewWriterToPreviewList}/>
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.Magazine.name,
                            "",
                        ),
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.MagazineWriters.name,
                            "",
                        ),
                    ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"جستجو"}
                            subTitle={"برای جستجو عبارت مورد نظر خود را وارد نمایید."}
                        >
                            <RaikoGridThreeColumn>
                                <RaikoSimpleInputOutlined
                                    labelText={"نام و نام خانوادگی"}
                                    setValue={setFullName}
                                    value={fullName}/>

                                <RaikoNumberInputOutlined
                                    labelText={"کد ملی"}
                                    setValue={setNationalCode}
                                    value={nationalCode}/>

                                <RaikoMobileInputOutlined
                                    labelText={"شماره همراه"}
                                    setValue={setPhoneNumber}
                                    value={phoneNumber}/>
                            </RaikoGridThreeColumn>
                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"نویسنده ها"}
                                hasCreateNewItem
                                handleCreateNewItem={_ => setDialogState(true)}
                                amount={totalItems}
                            />
                            <RaikoCustomTable
                                isLoading={tableListShimmerState}
                                data={writers}
                                header={tableHeader}
                                handlePaginationChange={handlePagination}
                                pageCount={pageCount}
                                rowClicked={handleSelectWriter}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}

const tableHeader = [
    {
        id: "number",
        label: "#"
    }, {
        id: "fullName",
        label: "نام"
    }, {
        id: "nationalCode",
        label: "کد ملی"
    }, {
        id: "phone",
        label: "شماره تماس"
    }, {
        id: "createdBy",
        label: "سازنده"
    }, {
        id: "createdAt",
        label: "تاریخ ساخت"
    }, {
        id: "enabled",
        label: "دسترسی"
    },
]
